import { Toggle, ToggleGroup } from "../ui/toggle-group";
import { type OperatorsSurface } from "../../appSettings";

export function OperatorsSurfaceToggle({
  value,
  onChange,
}: {
  value: OperatorsSurface;
  onChange: (value: OperatorsSurface) => void;
}) {
  return (
    <ToggleGroup
      aria-label="Operators mode"
      className="shrink-0"
      size="xs"
      variant="outline"
      value={[value]}
      onValueChange={(next) => {
        const surface = next[0];
        if (surface === "business" || surface === "code") {
          onChange(surface);
        }
      }}
    >
      <Toggle value="business">Business</Toggle>
      <Toggle value="code">Code</Toggle>
    </ToggleGroup>
  );
}
